import {useEffect, useState} from 'react';

import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

import ActionButtons from '../ActionsButtons';
import { Permission } from "../../../components/SessionInfo";
import {formatDistanceStrict} from "date-fns";
import locale from "date-fns/locale/ru";
import Checkbox from "@mui/material/Checkbox";

function SessionsTableRow({ row, triggerRefetch, permission, globalSelected, toggleInSet }) {
    const [now, setNow] = useState(+Date.now());
    const [selected, setSelected] = useState(globalSelected);
    useEffect(() => {
        console.log(globalSelected)
        setSelected(globalSelected)
        toggleInSet(row.sessionId, globalSelected);
    }, [globalSelected])
    useEffect(() => {
        const intervalId = setInterval(() => {
            setNow(+Date.now());
        }, 1000);
        return () => {
            clearInterval(intervalId);
        };
    }, []);

  return (
    <>
      <TableRow sx={{'&:last-child th': {border: 0}}}>
          {permission === Permission.WRITE
              ? <TableCell style={{ width: '74px' }}>
                    <Checkbox checked={selected} onChange={(e) => {
                            setSelected(e.target.checked);
                            toggleInSet(row.sessionId, e.target.checked);
                        }
                    }></Checkbox>
                </TableCell>
              : null
          }
        <TableCell>{row.login}</TableCell>
        <TableCell>{row.ip}</TableCell>
        <TableCell>{formatDistanceStrict(+new Date(row.createdAt), now, {locale})}</TableCell>
        {
          (permission === Permission.WRITE)?
            <TableCell sx={{whiteSpace: 'nowrap'}}>
                <ActionButtons toggleInSet={toggleInSet} selected={selected} id={row.sessionId} triggerRefetch={triggerRefetch}/>
            </TableCell>
          : ''
        }

      </TableRow>
    </>
  );
}

export default SessionsTableRow;
